import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export const ProtectedRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  const decodedToken = jwtDecode(token);

  if (allowedRoles && !allowedRoles.includes(decodedToken?.userRole)) {
    return <Navigate to={location.state?.from?.pathname || "/"} replace />;
  }

  return element;
};

export const RoleBasedRedirect = () => {
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  if (decodedToken?.userRole == "SuperAdmin")
    return <Navigate to="/super-admin/process-management" replace />;
  const interactionLandingCompanies = [
    "67e560a6ae2e0d3f96b5eb09",
    "69ba88379b1aea31bda6224e"
  ];

  if (
    (decodedToken?.userRole === "Admin" ||
      decodedToken?.userRole === "Manager" ||
      decodedToken?.userRole === "Curator") &&
    interactionLandingCompanies.includes(decodedToken?.companyId)
  ) {
    return <Navigate to="/user/audio-details" replace />;
  }
  if (decodedToken?.userRole == "Admin")
    return <Navigate to="/user/dashboard" replace />;
  if (decodedToken?.userRole == "Manager")
    return <Navigate to="/user/dashboard" replace />;
  if (decodedToken?.userRole == "Curator")
    return <Navigate to="/user/dashboard" replace />;
  if (decodedToken?.userRole == "Guest")
    return <Navigate to="/demo/audio/upload-file" replace />;
  if (decodedToken?.userRole == "QualityAnalyst")
    return <Navigate to="/qa/dashboard" replace />;
  if (decodedToken?.userRole == "Agent")
    return <Navigate to="/agent/dashboard" replace />;

  return (
    <div>
      No valid role. Redirecting to login...
      <Navigate to="/demo/audio/upload-file" replace />
    </div>
  );
};
